import {
  adminPage
} from "./admin_pages/adminPage";
import {
  sessionCreatePage
} from "./admin_pages/sessionCreatePage";
import {
  viewSessionPage
} from "./admin_pages/viewSessionPage";
import {
  accessSession
} from "./admin_pages/accessSession";
import {
  constellationSimple
} from "./admin_pages/constellationSimple";


if (( < any > window).current_page == "admin") {
  adminPage();
} else if (( < any > window).current_page == "session_create") {
  sessionCreatePage();
} else if (( < any > window).current_page == "view-session") {
  viewSessionPage();
} else if (( < any > window).current_page == "access-session") {
  accessSession();
} else if (( < any > window).current_page == "constellation-simple") {
  constellationSimple();
}